<div class="home-page">
  <app-hero></app-hero>
  <app-about></app-about>
  <app-services></app-services>
  <app-testimonials></app-testimonials>
  <app-contact></app-contact>
</div>